import React from "react"
import { motion } from "framer-motion"

const boxVariants = {
  first: {
    fill: ["#0CCE6B", "#E6E6E6", "#FFFFFF"],
    transition: {
      duration: 2,
      yoyo: Infinity,
    },
  },
  secound: {
    fill: ["#FFFFFF", "#0CCE6B", "#E6E6E6"],
    transition: {
      duration: 3,
      delay: 1,
      yoyo: Infinity,
    },
  },
  third: {
    fill: ["#E6E6E6", "#FFFFFF", "#0CCE6B"],
    transition: {
      duration: 3,
      yoyo: Infinity,
    },
  },
  sca: {
    scale: [1, 0.97, 1],
    transition: {
      duration: 5,
      yoyo: Infinity,
    },
  },
}

const HeroSvg = () => {
  return (
    <motion.svg
      variants={boxVariants}
      animate="sca"
      xmlns="http://www.w3.org/2000/svg"
      width="370"
      height="322"
    >
      <path
        fill="hsl(0, 0%, 100%)"
        d="M333.425 167.536a153.877 153.877 0 01-42.978 106.855 142.68 142.68 0 01-5.13 5.102 153.073 153.073 0 01-8.292 7.33 153.928 153.928 0 01-94.6 35.064c-1.152.026-2.308.039-3.469.039-27.579 0-62.266-14.722-93.744-35.103a319.799 319.799 0 01-7.743-5.175 245.16 245.16 0 01-3.57-2.486 317.501 317.501 0 01-34.487-28.158 223.45 223.45 0 01-19.891-21.259c-24.187-29.818-29.522-56.686 4.961-62.209a372.849 372.849 0 0011.887-2.091 331.913 331.913 0 0015.978-3.463c6.852-1.664 13.29-3.469 19.313-5.414a241.12 241.12 0 005.939-1.995c28.583-10.034 47.713-23.118 60.735-37.315a100.065 100.065 0 006.109-7.296 102.669 102.669 0 007.752-11.785 110.724 110.724 0 008.004-17.838l.118-.339c10.36-29.871 7.208-57.577 18.639-66.851 48.861-39.643 109.691 16.813 138.243 83.39a228.54 228.54 0 015.709 14.684 207.906 207.906 0 015.03 16.491c.422 1.638.826 3.272 1.2 4.906 2.779 11.963 4.287 23.761 4.287 34.916z"
      ></path>
      <path
        fill="#2F2E41"
        d="M182.425 321.887c-1.152.026-2.308.039-3.469.039-27.579 0-62.266-14.722-93.744-35.103a319.799 319.799 0 01-7.743-5.175l2.243-13.645 67.918-9.012 34.087 26.051z"
      ></path>
      <motion.path
        variants={boxVariants}
        animate="third"
        fill="#FFF"
        d="M185.695 78.24h-9.678a1.131 1.131 0 00-1.131 1.13v9.678a1.127 1.127 0 001.131 1.125h9.678a1.13 1.13 0 001.13-1.125V79.37a1.134 1.134 0 00-1.13-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M185.695 94.731h-9.678a1.131 1.131 0 00-1.131 1.13v9.678a1.126 1.126 0 001.131 1.125h9.678a1.13 1.13 0 001.13-1.125v-9.678a1.134 1.134 0 00-1.13-1.13zm0 16.492h-9.678a1.13 1.13 0 00-1.131 1.129v9.673a1.127 1.127 0 001.131 1.13h9.678a1.13 1.13 0 001.13-1.13v-9.673a1.132 1.132 0 00-1.13-1.129zm1.113 17.421a1.137 1.137 0 00-1.113-.93h-9.678a1.13 1.13 0 00-1.131 1.129v9.673a1.127 1.127 0 001.131 1.13h9.678a1.13 1.13 0 001.13-1.13v-9.673a1.016 1.016 0 00-.017-.199zm-.674 15.648a1.142 1.142 0 00-.439-.087h-9.678a1.126 1.126 0 00-1.131 1.13v9.673a1.122 1.122 0 001.131 1.129h9.678a1.13 1.13 0 001.13-1.129v-9.673a1.136 1.136 0 00-.691-1.043zm19.891-66.052h-9.678a1.13 1.13 0 00-1.13 1.13v9.678a1.126 1.126 0 001.13 1.125h9.678a1.13 1.13 0 001.131-1.125V79.37a1.134 1.134 0 00-1.131-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M206.025 94.731h-9.678a1.13 1.13 0 00-1.13 1.13v9.678a1.125 1.125 0 001.13 1.125h9.678a1.13 1.13 0 001.131-1.125v-9.678a1.134 1.134 0 00-1.131-1.13zm0 16.492h-9.678a1.13 1.13 0 00-1.13 1.129v9.673a1.126 1.126 0 001.13 1.13h9.678c.624 0 1.13-.506 1.131-1.13v-9.673a1.133 1.133 0 00-1.131-1.129zm0 16.491h-9.678c-.486 0-.917.312-1.07.773-.04.115-.06.235-.06.356v9.673a1.126 1.126 0 001.13 1.13h9.678c.624 0 1.13-.506 1.131-1.13v-9.673a1.133 1.133 0 00-1.131-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M206.025 144.205h-9.678a1.126 1.126 0 00-1.13 1.13v9.673a1.126 1.126 0 001.13 1.129h9.678c.624 0 1.13-.506 1.131-1.129v-9.673a1.132 1.132 0 00-1.131-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M226.356 78.24h-9.679a1.13 1.13 0 00-1.13 1.13v9.678a1.127 1.127 0 001.13 1.125h9.679a1.13 1.13 0 001.13-1.125V79.37a1.134 1.134 0 00-1.13-1.13zm0 16.491h-9.679a1.13 1.13 0 00-1.13 1.13v9.678a1.126 1.126 0 001.13 1.125h9.679a1.13 1.13 0 001.13-1.125v-9.678a1.134 1.134 0 00-1.13-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M226.356 111.223h-9.679a1.13 1.13 0 00-1.13 1.129v9.673a1.126 1.126 0 001.13 1.13h9.679a1.13 1.13 0 001.13-1.13v-9.673a1.132 1.132 0 00-1.13-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M226.356 127.714h-9.679a1.13 1.13 0 00-1.13 1.129v9.673a1.126 1.126 0 001.13 1.13h9.679a1.13 1.13 0 001.13-1.13v-9.673a1.133 1.133 0 00-1.13-1.129zm0 16.491h-9.679a1.128 1.128 0 00-1.13 1.13v9.673a1.126 1.126 0 001.13 1.129h9.679a1.13 1.13 0 001.13-1.129v-9.673a1.13 1.13 0 00-1.13-1.13zm20.33-65.965h-9.678a1.132 1.132 0 00-1.131 1.13v9.678a1.128 1.128 0 001.131 1.125h9.678a1.13 1.13 0 001.131-1.125V79.37a1.134 1.134 0 00-1.131-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="third"
        fill="#FFF"
        d="M246.686 94.731h-9.678a1.132 1.132 0 00-1.131 1.13v9.678a1.13 1.13 0 001.131 1.125h9.678a1.13 1.13 0 001.131-1.125v-9.678a1.134 1.134 0 00-1.131-1.13zm0 16.492h-9.678a1.13 1.13 0 00-1.131 1.129v9.673a1.132 1.132 0 001.131 1.13h9.678c.624 0 1.13-.506 1.131-1.13v-9.673a1.133 1.133 0 00-1.131-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M246.686 127.714h-9.678c-.624 0-1.13.506-1.131 1.129v9.673a1.132 1.132 0 001.131 1.13h9.678c.624 0 1.13-.506 1.131-1.13v-9.673a1.133 1.133 0 00-1.131-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M246.686 144.205h-9.678a1.126 1.126 0 00-1.131 1.13v9.673a1.131 1.131 0 001.131 1.129h9.678c.624 0 1.13-.506 1.131-1.129v-9.673a1.132 1.132 0 00-1.131-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="third"
        fill="#FFF"
        d="M267.017 78.24h-9.683a1.13 1.13 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.683a1.13 1.13 0 001.13-1.125V79.37a1.134 1.134 0 00-1.13-1.13zm0 16.491h-9.683a1.13 1.13 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.683a1.13 1.13 0 001.13-1.125v-9.678a1.134 1.134 0 00-1.13-1.13zm0 16.492h-9.683a1.129 1.129 0 00-1.126 1.129v9.673a1.126 1.126 0 001.126 1.13h9.683a1.13 1.13 0 001.13-1.13v-9.673a1.132 1.132 0 00-1.13-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M267.017 127.714h-9.683a1.129 1.129 0 00-1.126 1.129v9.673a1.126 1.126 0 001.126 1.13h9.683a1.13 1.13 0 001.13-1.13v-9.673a1.133 1.133 0 00-1.13-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M267.017 144.205h-9.683a1.129 1.129 0 00-1.126 1.13v9.673a1.126 1.126 0 001.126 1.129h9.683a1.13 1.13 0 001.13-1.129v-9.673a1.13 1.13 0 00-1.13-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="third"
        fill="#FFF"
        d="M287.347 78.24h-9.683a1.131 1.131 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.683c.623 0 1.128-.503 1.13-1.125V79.37a1.134 1.134 0 00-1.13-1.13zm0 16.491h-9.683a1.131 1.131 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.683c.623 0 1.128-.503 1.13-1.125v-9.678a1.134 1.134 0 00-1.13-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M287.347 111.223h-9.683a1.13 1.13 0 00-1.126 1.129v9.673a1.127 1.127 0 001.126 1.13h9.683a1.13 1.13 0 001.13-1.13v-9.673a1.132 1.132 0 00-1.13-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M287.347 127.714h-9.683a1.13 1.13 0 00-1.126 1.129v9.673a1.127 1.127 0 001.126 1.13h9.683a1.13 1.13 0 001.13-1.13v-9.673a1.133 1.133 0 00-1.13-1.129z"
      ></motion.path>
      <path
        fill="#FFF"
        d="M287.347 144.205h-9.683a1.125 1.125 0 00-1.126 1.13v9.673a1.127 1.127 0 001.126 1.129h9.683a1.13 1.13 0 001.13-1.129v-9.673a1.13 1.13 0 00-1.13-1.13z"
      ></path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M307.677 78.24h-9.682a1.13 1.13 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.682a1.13 1.13 0 001.131-1.125V79.37a1.134 1.134 0 00-1.131-1.13zm0 16.491h-9.682a1.13 1.13 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.682a1.13 1.13 0 001.131-1.125v-9.678a1.134 1.134 0 00-1.131-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M307.677 111.223h-9.682a1.129 1.129 0 00-1.126 1.129v9.673a1.126 1.126 0 001.126 1.13h9.682a1.13 1.13 0 001.131-1.13v-9.673a1.133 1.133 0 00-1.131-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="third"
        fill="#FFF"
        d="M307.677 127.714h-9.682a1.129 1.129 0 00-1.126 1.129v9.673a1.126 1.126 0 001.126 1.13h9.682a1.13 1.13 0 001.131-1.13v-9.673a1.133 1.133 0 00-1.131-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M307.677 144.205h-9.682a1.127 1.127 0 00-1.126 1.13v9.673a1.126 1.126 0 001.126 1.129h9.682a1.13 1.13 0 001.131-1.129v-9.673a1.13 1.13 0 00-1.131-1.13zm20.331-65.965h-9.683a1.13 1.13 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.683a1.13 1.13 0 001.13-1.125V79.37a1.134 1.134 0 00-1.13-1.13zm0 16.491h-9.683a1.13 1.13 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.683a1.13 1.13 0 001.13-1.125v-9.678a1.134 1.134 0 00-1.13-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M328.008 111.223h-9.683a1.13 1.13 0 00-1.126 1.129v9.673a1.127 1.127 0 001.126 1.13h9.683a1.13 1.13 0 001.13-1.13v-9.673a1.132 1.132 0 00-1.13-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M328.008 127.714h-9.683a1.13 1.13 0 00-1.126 1.129v9.673a1.127 1.127 0 001.126 1.13h9.683a1.13 1.13 0 001.13-1.13v-9.673a1.133 1.133 0 00-1.13-1.129zm0 16.491h-9.683a1.125 1.125 0 00-1.126 1.13v9.673a1.127 1.127 0 001.126 1.129h9.683a1.13 1.13 0 001.13-1.129v-9.673a1.13 1.13 0 00-1.13-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M348.338 78.24h-9.682a1.13 1.13 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.682a1.13 1.13 0 001.131-1.125V79.37a1.134 1.134 0 00-1.131-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M348.338 94.731h-9.682a1.13 1.13 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.682a1.13 1.13 0 001.131-1.125v-9.678a1.134 1.134 0 00-1.131-1.13zm0 16.492h-9.682a1.129 1.129 0 00-1.126 1.129v9.673a1.126 1.126 0 001.126 1.13h9.682c.624 0 1.13-.506 1.131-1.13v-9.673a1.133 1.133 0 00-1.131-1.129zm0 16.491h-9.682a1.129 1.129 0 00-1.126 1.129v9.673a1.126 1.126 0 001.126 1.13h9.682c.624 0 1.13-.506 1.131-1.13v-9.673a1.133 1.133 0 00-1.131-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M348.338 144.205h-9.682a1.125 1.125 0 00-1.126 1.13v9.673a1.126 1.126 0 001.126 1.129h9.682c.624 0 1.13-.506 1.131-1.129v-9.673a1.132 1.132 0 00-1.131-1.13zm20.331-65.965h-9.683a1.13 1.13 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.683a1.13 1.13 0 001.13-1.125V79.37a1.134 1.134 0 00-1.13-1.13zm0 16.491h-9.683a1.13 1.13 0 00-1.126 1.13v9.678c0 .621.504 1.125 1.126 1.125h9.683a1.13 1.13 0 001.13-1.125v-9.678a1.134 1.134 0 00-1.13-1.13z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="first"
        fill="#0CCE6B"
        d="M368.669 111.223h-9.683a1.129 1.129 0 00-1.126 1.129v9.673a1.123 1.123 0 001.126 1.13h9.683a1.13 1.13 0 001.13-1.13v-9.673a1.132 1.132 0 00-1.13-1.129z"
      ></motion.path>
      <motion.path
        variants={boxVariants}
        animate="secound"
        fill="#E6E6E6"
        d="M368.669 127.714h-9.683a1.129 1.129 0 00-1.126 1.129v9.673a1.123 1.123 0 001.126 1.13h9.683a1.13 1.13 0 001.13-1.13v-9.673a1.133 1.133 0 00-1.13-1.129zm0 16.491h-9.683a1.125 1.125 0 00-1.126 1.13v9.673a1.123 1.123 0 001.126 1.129h9.683a1.13 1.13 0 001.13-1.129v-9.673a1.13 1.13 0 00-1.13-1.13z"
      ></motion.path>
      <path fill="#2F2E41" d="M146.128 286.824h-.269l.23-.031z"></path>
      <path
        fill="#FFB6B6"
        d="M93.257 76.799c0-16.397 13.3-29.689 29.706-29.689 16.405 0 29.705 13.292 29.705 29.689s-13.3 29.689-29.705 29.689c-16.406 0-29.706-13.292-29.706-29.689z"
      ></path>
      <path
        fill="#2F2E41"
        d="M148.977 55.031s7.769-14.844-9.324-16.194c0 0-14.572-13.211-29.424-2.415 0 0-8.102 0-12.532 9.163 0 0-6.371-2.415-7.772 4.048 0 0-4.662 13.496 0 25.641 4.663 12.145 6.212 13.495 6.212 13.495s-7.662-25.464 10.986-26.813c18.649-1.35 39.516-12.998 41.07 1.847 1.554 14.845 3.893 18.502 3.893 18.502s14.761-21.201-3.109-27.274z"
      ></path>
      <path
        fill="#CACACA"
        d="M199.803 149.967l-.095.504-1.074 5.666-7.422 39.197-.439 2.307-.922 4.88-1.261 6.657-2.795 14.753-.8 4.228-.3 1.586-.105.557-.83 4.376-.252 1.321-2.026 15.005-1.77 13.075 5.922 5.919-3.531 3.528-2.317 13.267.004.03H85.212a328.934 328.934 0 01-11.313-7.661l.778-5.823s2.679-10.398 1.553-11.641c-1.122-1.243-3.583-3.464-3.583-3.464l3.1-7.23.43-1.004-.721-14.962-.018-.36-.239-4.933-.03-.634-.048-.952-.918-18.981-.017-.313-.278-5.753-.261-5.471-.113-2.307-1.117-23.088-.757-15.678-.661-13.65 2.657-.899 28.413-9.651 11.769-15.292 24.496.182 11.991.092 20.009 18.546 4.552 2.173.035.017 3.265 1.56 8.278 3.95 8.753 4.181 4.491 2.142z"
      ></path>
      <path
        fill="#FFB6B6"
        d="M117.004 242.282a13.175 13.175 0 01-11.117-.748 13.161 13.161 0 01-6.563-8.999l-46.33-6.569L69.1 207.758l41.526 9.03c6.655-.849 12.893 3.411 14.52 9.916 1.627 6.504-1.871 13.197-8.142 15.579z"
      ></path>
      <path
        fill="#CACACA"
        d="M96.347 209.178a5.88 5.88 0 00-3.43-2.116l-19.009-3.95-1.952-.404a8.23 8.23 0 01-5.448-3.941 8.315 8.315 0 01-1.065-3.433 8.201 8.201 0 01.387-3.251l6.587-19.837 4.273-12.871c.518-1.553.824-3.168.909-4.802a18.835 18.835 0 00-3.943-12.554 18.568 18.568 0 00-21.309-5.927 18.509 18.509 0 00-11.335 12.471l-4.643 16.882-9.579 34.803a25.091 25.091 0 003.388 20.677 25.12 25.12 0 0017.899 10.906l27.379 3.207 12.669 1.486a5.867 5.867 0 006.452-4.662c.021-.079.037-.159.048-.239l.305-1.878 2.578-15.808.026-.161a5.856 5.856 0 00-1.187-4.598z"
      ></path>
      <path
        fill="#FFB6B6"
        d="M146.514 242.789c3.796.881 7.788.036 10.9-2.307a13.159 13.159 0 005.228-9.834l44.94-13.034-18.513-15.757-39.838 14.793a13.232 13.232 0 00-2.717 26.139z"
      ></path>
      <path
        fill="#CACACA"
        d="M229.895 188.459l-21.374-49.165a18.611 18.611 0 00-8.813-9.277 18.864 18.864 0 00-4.431-1.53 18.322 18.322 0 00-8.469.157 18.609 18.609 0 00-11.887 9.442.532.532 0 00-.035.061 18.72 18.72 0 00-.161 16.882l.265.53 15.105 30.319a8.21 8.21 0 01-4.565 11.381l-1.061.382-19.079 6.888a5.864 5.864 0 00-3.621 7.296l.048.152 5.347 17.104c.026.078.053.156.083.234.047.148.105.292.174.43a5.863 5.863 0 006.874 3.273l10.295-2.716 2.1-.557 26.587-7.017a25.114 25.114 0 0016.184-13.32 25.09 25.09 0 00.434-20.949z"
      ></path>
      <path
        fill="#3F3D56"
        d="M19.521 229.745a223.45 223.45 0 0019.891 21.259h196.509a7.148 7.148 0 017.139 7.139l.283 49.769a154.5 154.5 0 0033.682-21.089 152.022 152.022 0 008.292-7.33 149.586 149.586 0 005.13-5.102 154.525 154.525 0 0029.922-44.646z"
      ></path>
      <path
        fill="#FFF"
        d="M290.447 274.391a142.68 142.68 0 01-5.13 5.102h-41.831v-5.102z"
      ></path>
      <path
        fill="#3F3D56"
        d="M199.412 111.223a2.408 2.408 0 00-2.117-1.261H54.756a2.415 2.415 0 00-2.409 2.412v85.267h147.361v-85.267c.002-.403-.1-.799-.296-1.151z"
      ></path>
      <path
        fill="#3F3D56"
        d="M52.218 195.332v10.522a3.322 3.322 0 003.323 3.322h54.39v20.765h-.722a.432.432 0 00-.432.432v1.444c0 .239.193.432.432.432h33.764a.432.432 0 00.432-.432v-1.444a.433.433 0 00-.432-.432h-.723v-20.765h54.39a3.323 3.323 0 003.324-3.322v-10.522z"
      ></path>
      <path
        fill="#0CCE6B"
        d="M110.694 151.529c0-7.514 6.094-13.604 13.612-13.604 7.517 0 13.611 6.09 13.611 13.604 0 7.513-6.094 13.604-13.611 13.604-7.518 0-13.612-6.091-13.612-13.604zM158.986 75.177h-2.174c0-16.426-16.265-27.19-32.674-27.199a35.862 35.862 0 00-7.108.691c-2.635.526-5.37 1.156-8.057 1.978-10.596 3.246-20.422 9.521-20.422 24.53a34.126 34.126 0 001.105 8.639l-2.105.547a36.46 36.46 0 01-1.174-9.186c0-13.115 5.387-22.123 14.692-27.494 4.891-2.825 10.861-4.645 17.7-5.532a42.287 42.287 0 018.587-.261c18.869 1.356 31.63 15.818 31.63 33.287z"
      ></path>
      <path
        fill="#0CCE6B"
        d="M162.608 76.38l-.857-6.327a6.824 6.824 0 00-2.174-4.154 6.876 6.876 0 00-5.76-1.738l-1.361.187a2.838 2.838 0 00-1.892 1.099 2.85 2.85 0 00-.561 2.117l1.979 14.574a2.86 2.86 0 002.304 2.421 2.7 2.7 0 00.913.026l1.522-.204a6.864 6.864 0 005.004-3.303 7.277 7.277 0 00.883-4.698z"
      ></path>
      <path
        fill="#FFF"
        d="M151.577 64.613c-.399.194-.746.48-1.013.834a2.85 2.85 0 00-.561 2.117l1.979 14.574a2.86 2.86 0 002.304 2.421z"
      ></path>
      <path
        fill="#3F3D56"
        d="M162.608 76.38l-.857-6.327a6.824 6.824 0 00-2.174-4.154l1.97 14.501c.029.233.089.461.178.678a7.277 7.277 0 00.883-4.698zM154.357 78.073c-.226-1.665.073-3.08.668-3.161.595-.08 1.26 1.204 1.486 2.869.226 1.664-.073 3.079-.668 3.16-.595.081-1.26-1.204-1.486-2.868zM153.053 70.251c-.226-1.665.073-3.08.668-3.16.594-.081 1.26 1.203 1.486 2.868.226 1.664-.073 3.079-.668 3.16-.595.081-1.26-1.203-1.486-2.868z"
      ></path>
      <path
        fill="#3F3D56"
        d="M161.314 73.293c-.226-1.665.073-3.08.667-3.161.595-.08 1.261 1.204 1.487 2.869.226 1.664-.073 3.079-.668 3.16-.595.081-1.261-1.204-1.486-2.868z"
      ></path>
      <path
        fill="#0CCE6B"
        d="M96.382 90.256l-3.348-13.91a2.618 2.618 0 00-3.165-1.938l-1.296.313a6.476 6.476 0 00-4.778 7.804l1.5 6.24a6.882 6.882 0 002.322 3.746 6.438 6.438 0 005.534 1.221l1.292-.313c.341-.08.662-.229.943-.439a2.604 2.604 0 00.996-2.724z"
      ></path>
      <path
        fill="#3F3D56"
        d="M87.592 84.963c-.394-1.633-.239-3.071.344-3.211.584-.141 1.376 1.069 1.769 2.703.393 1.633.239 3.071-.345 3.211-.583.141-1.375-1.07-1.768-2.703zM83.244 86.267c-.393-1.634-.239-3.071.344-3.212.584-.14 1.376 1.07 1.769 2.703.394 1.634.239 3.072-.344 3.212-.584.14-1.376-1.07-1.769-2.703z"
      ></path>
      <path
        fill="#FFF"
        d="M96.595 90.203l-3.348-13.909a2.838 2.838 0 00-2.3-2.138l4.57 18.998a2.83 2.83 0 001.078-2.951z"
      ></path>
      <path
        fill="#3F3D56"
        d="M84.551 79.77a2.806 2.806 0 00-.508-1.065 6.396 6.396 0 00-.248 3.82l1.5 6.24a6.882 6.882 0 002.322 3.746z"
      ></path>
    </motion.svg>
  )
}

export default HeroSvg
